import * as React from 'react'

import { getTeacher }    from '../../project-utils'
import InjectAccountType from '../atoms/InjectAccountType'

const TeacherWording = () => {
  return (
    <InjectAccountType>
      {({ accountType }) => <>{getTeacher(accountType)}</>}
    </InjectAccountType>
  )
}

export default TeacherWording



// WEBPACK FOOTER //
// ./src/components/dynamic-project-wording/TeacherWording.tsx